import { authenticationApiUrls as apiUrl } from "@/apps/merchant3/services/apiClient/apiUrl";
import { AxiosResponse } from "axios";
import { jwtApiClient } from "@/apps/merchant3/services/apiClient/apiClient";

export interface ChatbotSunshineJwtResponse {
  jwt: string;
}

export default class ChatBotAuthService {
  public async createSunshineJwt(): Promise<ChatbotSunshineJwtResponse> {
    return await jwtApiClient
      .get(apiUrl.BUILD_CLERK_CHATBOT_JWT, {
        headers: {
          Prefer: "code=200, example=default",
        },
      })
      .then((response: AxiosResponse) => {
        return response.data;
      });
  }
}
